export default __webpack_public_path__ + "static/media/bell.43b75b03.svg";